import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import './styles.scss'

const NotFound = () => {
  const navigate = useNavigate()

  return (
    <div className="not-found">
      <div className="not-found__content">
        <div className="not-found__icon">
          <FontAwesomeIcon icon={solid('box-open')} />
        </div>
        <h1 className="not-found__code">404</h1>
        <h2 className="not-found__title">Page Not Found</h2>
        <p className="not-found__message">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found__actions">
          <button className="not-found__btn not-found__btn--primary" onClick={() => navigate('/')}>
            <FontAwesomeIcon icon={solid('house')} /> Go Home
          </button>
          <button className="not-found__btn not-found__btn--secondary" onClick={() => navigate(-1)}>
            <FontAwesomeIcon icon={solid('arrow-left')} /> Go Back
          </button>
        </div>
      </div>
    </div>
  )
}

export default NotFound
